import axiosInstance from '../../../core/api/axios';
import {
  LiveClass,
  LiveClassDto,
  LiveClassRegistrantResponse,
  RecordedClassesResponse,
} from '../models/LiveClassDto.model';

type FetchRecordedClassesParams = {
  origin?: 'challenge' | 'live';
  page?: number;
  limit?: number;
  disciplinas?: string[];
  months?: number[];
};

export async function fetchLiveClasses(
  startDate: string,
  endDate: string,
  origin: 'aprova-live' | 'challenge'
): Promise<LiveClassDto[]> {
  try {
    const response = await axiosInstance.get(
      `/aulas-ao-vivo/${startDate}/${endDate}?origin=${origin}`
    );

    return response.data;
  } catch (e: any) {
    throw new Error(e);
  }
}

export async function registerToLiveClass(
  eventId: string
): Promise<LiveClassRegistrantResponse> {
  const response = await axiosInstance.post(
    `/aulas-ao-vivo/webinar/registrant/`,
    {
      monitoring: eventId,
    }
  );

  return response.data;
}

export async function fetchRecordedClasses(
  {
    origin,
    page = 1,
    limit = 20,
    disciplinas = [],
    months = [],
  }: FetchRecordedClassesParams = {}
): Promise<RecordedClassesResponse> {
  try {
    const params = new URLSearchParams();

    if (origin) params.set('origin', origin);
    params.set('page', String(page));
    params.set('limit', String(limit));
    disciplinas.forEach((disciplinaId) => {
      params.append('disciplinas', disciplinaId);
    });
    months.forEach((month) => {
      params.append('months', String(month));
    });

    const response = await axiosInstance.get(
      `/aulas-ao-vivo/recordedClasses?${params.toString()}`
    );

    return response.data;
  } catch (e: any) {
    throw new Error(e);
  }
}

export async function fetchLiveClassBySlug(slug: string): Promise<LiveClass> {
  try {
    const response = await axiosInstance.get(`/aulas-ao-vivo/${slug}`);

    return response.data;
  } catch (e: any) {
    throw new Error(e);
  }
}

export async function markLiveClassAsFinished(slug: string) {
  try {
    const response = await axiosInstance.post(
      `/aulas-ao-vivo/${slug}/finished`,
      {}
    );
    return response.data;
  } catch (e: any) {
    throw new Error(e);
  }
}
